// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"90c26243","274":"e2ed79f0","421":"e9c00acb","453":"2cf65d82","455":"5e8096b2","628":"449a8636","977":"30b7b383","987":"39c3145c"}[chunkId] + ".chunk.js";
};